import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { PersonalRoadUserAccidentResponse } from '../../shared/models/personal-road-user-accident';
import { Observable } from 'rxjs';

interface RoadUserReportResponse {
    message: string;
    policyList: PersonalRoadUserAccidentResponse[];
}
@Injectable({
    providedIn: 'root',
})
export class RoadAccidentCoverService {
    private baseUrl: string = environment.apiUrl;

    constructor(private http: HttpClient) {}

    createRoadAccidentCover(payload: any) {
        return this.http.post<any>(
            `${this.baseUrl}/api/road-user-personal-accident`,
            payload
        );
    }

    fetchQuote(quoteId: number) {
        return this.http.get<any>(
            `${this.baseUrl}/api/road-user-personal-accident/${quoteId}`
        );
    }

    approveRoadAccidentCover(payload: any, quoteId: number) {
        return this.http.put<any>(
            `${this.baseUrl}/api/road-user-personal-accident/${quoteId}/approve`,
            payload
        );
    }

    report(reportPayload: any): Observable<RoadUserReportResponse> {
        return this.http.post<any>(
            `${this.baseUrl}/api/report/road-user-personal-accident`,
            reportPayload
        );
    }

    fetchAllCustomerQuotations(customerId: number) {
        return this.http.get<any>(
            `${this.baseUrl}/api/road-user-personal-accident/search?customerId=${customerId}`
        );
    }
}
